import { render, staticRenderFns } from "./MMP_DPR_AdminConsole.vue?vue&type=template&id=ab25927e&scoped=true&"
import script from "./MMP_DPR_AdminConsole.vue?vue&type=script&lang=js&"
export * from "./MMP_DPR_AdminConsole.vue?vue&type=script&lang=js&"
import style0 from "./MMP_DPR_AdminConsole.vue?vue&type=style&index=0&id=ab25927e&prod&scoped=true&lang=css&"
import style1 from "./MMP_DPR_AdminConsole.vue?vue&type=style&index=1&id=ab25927e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab25927e",
  null
  
)

export default component.exports